import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { EditDescription } from "partials/edit-name-description";
import { Button, Card, CardHeader, Label } from "reactstrap";
import ConfirmSuccess from "../core/ui/confirm-success";
import SessionContext from "SessionContext";
import UploadStatus from "./upload-status";

function LocationUploadDetails(props) {
  const session = useContext(SessionContext);
  const history = useHistory();
  const access = session.appState.userCan;

  const [showEditModal, setShowEditModal] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [failedToLoad, setFailedToLoad] = useState(false);
  const [upload, setUplod] = useState();
  const [loading, setLoading] = useState(true);

  const toggleEditNameModal = () => {
    setShowEditModal(!showEditModal);
  };

  const onAcceptChanges = (_description) => {
    let updatedDescription = { ...upload, description: _description };
    session
      .command(
        "upload/rename_location_upload",
        updatedDescription,
        {},
        { defaultErrorHandling: false }
      )
      .then((res) => {
        setShowEditModal(false);
        setShowSuccess(true);
        setTimeout(() => {
          history.push("/location-uploads");
        }, 2000);
      })
      .catch((error) => {
        console.log("Failed to update the upload file", error);
      });
  };

  useEffect(() => {
    if(props && 'subpage' in props && loading) {
      session.query("uploads/get", { id: props.subpage })
      .then((res) => { 
        setUplod(res);
        setFailedToLoad(false);
        setLoading(false);
      })
      .catch((error) => {
        setFailedToLoad(true);
        setLoading(false);
        console.log("Failed to load data", error);
      })
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  if(failedToLoad) {
    return (
      <div className="page upload-details-page">
        <div className="list-header sticky-page-header">
        <Link to="/location-uploads">
          <Button type="button" className="new-button">
            <i className="bi bi-chevron-left" /> Location Uploads
          </Button>
        </Link>
        <h1>Location Details</h1>
        <i className="spacer" />
      </div>
        <div className="m-5">
          <h5>Details could not be found for that upload.</h5>
        </div>
      </div>
    )
  }

  if(loading) {
    return (
      <div className="page upload-details-page">
        <div className="list-header sticky-page-header">
        <Link to="/location-uploads">
          <Button type="button" className="new-button">
            <i className="bi bi-chevron-left" /> Location Uploads
          </Button>
        </Link>
        <h1>Location Details</h1>
        <i className="spacer" />
      </div>
        <div className="m-5">
          <h5>Loading...</h5>
        </div>
      </div>
    )
  }

  return (
    <div className="page upload-details-page">
      <div className="list-header sticky-page-header">
        <Link to="/location-uploads">
          <Button type="button" className="new-button">
            <i className="bi bi-chevron-left" /> Location Uploads
          </Button>
        </Link>
        <h1>Location Details</h1>
        <i className="spacer" />
      </div>

      <section className="upload-details mt-4 mb-4">
        <Card className="preview">
          <CardHeader>
            <h2>
              Filename:
              <span className="upload-details-info">{upload.filename}</span>
            </h2>
          </CardHeader>
          <div className="labeled-items horizontal m-3">
            <div className="labeled-item primary description-row">
              <Label>
                Description:
                {access('location_edit') && <>
                  <i
                    className="bi bi-pencil"
                    title="Edit Description"
                    onClick={toggleEditNameModal}
                  />
                </>}
              </Label>
              <span className="value">{upload.description}</span>
            </div>
          </div>
          <div className="labeled-items horizontal m-3 second-row">
            <div className="labeled-item primary">
              <Label>Uploaded BY:</Label>
              <span className="value">{upload.uploaded_by}</span>
            </div>
            <div className="labeled-item primary">
              <Label>Date/Time:</Label>
              <span className="value">{upload.ingress_date}</span>
            </div>
            <div className="labeled-item primary">
              <Label>Status:</Label>
              <span className="value">{upload.status}</span>
            </div>
          </div>
        </Card>

        {(upload.status === "Error") ? (
          <Card className="error-logs-card">
            <CardHeader className="error-log-header">
              <h2>Location Error Logs:</h2>
            </CardHeader>
            <UploadStatus props_id={props.subpage} />
          </Card>
        ) : ""}

      </section>
      <EditDescription
        toggleShowModal={toggleEditNameModal}
        data={{ name: upload.filename, description: upload.description || "" }}
        confirmChanges={onAcceptChanges}
        showModal={showEditModal}
      />
      <ConfirmSuccess
        show={showSuccess}
        label="Location Upload updated successfully."
      />
    </div>
  );
}

export default LocationUploadDetails;
